<template lang="pug">
  .custom-options
    component(
      v-for="opt in controls"
      :is="opt.type"
      :required="opt.required"
      :key="opt.id"
      :options="opt.options"
      :label="opt.title"
      :modelValue="buyRequest.options[opt.id]"
      @update:modelValue="setOption(opt.id, $event)"
    )
</template>
<script>
import { useProductStore } from '@/js/stores/productStore'

export default {
  name  : 'CustomOptions',
  props : {
    buyRequest: {
      type     : Object,
      required : true,
    },
  },
  emits: ['update'],

  setup() {
    const productStore = useProductStore()

    return { productStore }
  },

  data: () => ({
    controls: [],
  }),

  computed: {
    products() {
      return this.productStore.products
    },
    product() {
      return this.products[this.buyRequest.productId]
    },
  },

  watch: {
    'buyRequest.productId': {
      immediate: true,
      handler() {
        this.controls = this.product.customOptions?.map(opt => {
          let type = 'RogueSelect'

          if (opt.type === 'radio' && !this.buyRequest._id) {
            type = 'Swatches'
          } else if (opt.type === 'field' || opt.type === 'area') {
            type = 'RogueInput'
          }

          return {
            title    : opt.title,
            id       : opt.id,
            required : opt.required,
            type,
            options  : opt.values?.sort((a, b) => a.position - b.position)
              .map(val => ({
                value : val.id,
                label : this.getOptionLabel(val),
              })),
          }
        })
      },
    },
  },

  methods: {
    setOption(id, val) {
      this.buyRequest.options[id] = val
      this.$emit('update')
    },
    getOptionLabel(val) {
      const { title, price } = val
      if (price) {
        return `${this.__(title, 'auto')} (${this.$rogue.currency(price, { plusSymbol: true, euTaxClass: true })})`
      }

      return title
    },
  },
}
</script>
<style lang="scss" scoped>
.option {
  margin-top: $space-s;
}
</style>
